import React from 'react';
import { OnboardingStepProps } from '../../../types/onboarding';
import { useOnboardingProgress } from '../../../hooks/onboarding';
import { WelcomeContainer, WelcomeIcon, WelcomeTitle, WelcomeDescription } from '../../../styles/onboarding/Onboarding.styles';
import styled from 'styled-components';
import { theme } from '../../../styles/theme';

const CompletionStats = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${theme.spacing.md};
  padding: ${theme.spacing.lg};
  background: ${theme.colors.background.card};
  border-radius: ${theme.borderRadius.md};
  margin-top: ${theme.spacing.lg};
`;

const StatItem = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 1rem;
  color: ${theme.colors.text.primary};
`;

const StatLabel = styled.span`
  color: ${theme.colors.text.secondary};
`;

const StatValue = styled.span`
  font-weight: 600;
  color: ${theme.colors.primary};
`;

export const CompletionStep: React.FC<OnboardingStepProps> = () => {
  const progress = useOnboardingProgress();

  return (
    <WelcomeContainer>
      <WelcomeIcon>🎉</WelcomeIcon>
      <WelcomeTitle>You're All Set!</WelcomeTitle>
      <WelcomeDescription>
        Your profile is {progress.percentage}% complete. You're ready to start exploring and making connections!
      </WelcomeDescription>
      
      <CompletionStats>
        <StatItem>
          <StatLabel>Profile Completion</StatLabel>
          <StatValue>{progress.percentage}%</StatValue>
        </StatItem>
        <StatItem>
          <StatLabel>Steps Completed</StatLabel>
          <StatValue>{progress.completedCount} of {progress.totalSteps}</StatValue>
        </StatItem>
        {progress.skippedCount > 0 && (
          <StatItem>
            <StatLabel>Steps Skipped</StatLabel>
            <StatValue>{progress.skippedCount}</StatValue>
          </StatItem>
        )}
      </CompletionStats>
    </WelcomeContainer>
  );
};

